import {gql} from '@apollo/client';
import {
  GOAL,
  OV_POT_FRAGMENT,
  OV_RECOMMENDATION,
  RECOMMENDS_FRAGMENT,
} from '../../../graphql/fragments';
import {PROTECTION_POT} from '../../potQueries';

export const LIST_OV_RECOMMENDATIONS = gql`
  ${OV_RECOMMENDATION}
  query OVRecommends($entityName: String!, $entityId: UUID!) {
    ovrecommends(entityName: $entityName, entityId: $entityId) {
      ...OVRecommendation
    }
  }
`;

export const DELETE_OV_RECOMMENDATION = gql`
  mutation DeleteOvrecommend($ovrecommendId: UUID!) {
    deleteOvrecommend(ovrecommendId: $ovrecommendId) {
      ok
      ovrecommendId
    }
  }
`;

export const OV_PROTECTION_RECOMMENDATION_DETAILS = gql`
  query OvProtectionrecommendDetails($ovrecommendId: UUID!) {
    ovrecommendDetails(ovrecommendId: $ovrecommendId) {
      id
      name
      dateUpdated
      dateCreated
      solutionType
      isXo
      isSppDaXo
      isPensionSharing
      isDependantsPension
      isAps
      selectedMandate
      goal {
        ...Goal
      }
      review {
        id
        dateSubmitted
      }
      contact {
        id
        simplifiedName
      }
      account {
        id
      }
      productProvider {
        id
        name
        isBank
        reportName
      }
      productName {
        id
        name
        reportName
      }
      recommends {
        id
        name
        curoId
        isFailedSubmission
      }
      pots {
        id
        fees {
          id
        }
        legacyInitialFee
        legacyInitialEmployerFee
        initialFee {
          id
        }
        initialEmployerFee {
          id
        }
        pot {
          ...ProtectionPot
        }
        adhocFeeType
        adhocFeeAmount
        adhocFeeDate
        adhocFeeReason
      }
      sourceOfFunds
      urgency
      urgencyReason
      isFinalised
      action
      isNewPlanRequired
      # ownership
      planType
      withdrawalReason
      withdrawalAmount
      startDate
      endDate
      note
    }
  }
  ${PROTECTION_POT}
  ${GOAL}
`;
export const OV_RECOMMENDATION_DETAILS = gql`
  ${OV_RECOMMENDATION}
  query OvrecommendDetails($ovrecommendId: UUID!) {
    ovrecommendDetails(ovrecommendId: $ovrecommendId) {
      ...OVRecommendation
    }
  }
`;

export const OV_RECOMMENDATION_ASSOCIATED_RECCS = gql`
  query OvrecommendAssociatedReccs($ovrecommendId: UUID!) {
    ovrecommendDetails(ovrecommendId: $ovrecommendId) {
      pots {
        id
        pot {
          id
          isShellPlan
          servicingRights
          originalOvrId
          isDummy
          inTrust
          ovrecommendpots {
            ovrecommend {
              id
              name
              isDeleted
            }
          }
        }
      }
    }
  }
`;

export const UPSERT_RECOMMENDATION = gql`
  ${RECOMMENDS_FRAGMENT}
  mutation UpsertOvrecommend(
    $ovrecommendId: UUID
    $reviewId: UUID
    $contactId: UUID
    $accountId: UUID
    $goalId: UUID
    $productProviderId: UUID
    $productNameId: UUID
    $name: String
    $action: OVRecommendActionEnum!
    $isNewPlanRequired: Boolean
    # $ownership: String
    $planType: String
    $solutionType: String
    $isXo: Boolean
    $withdrawalReason: String
    # $withdrawalAmount: Decimal # not used, instead calculated
    $urgency: String
    $urgencyReason: String
    $startDate: DateTime
    $endDate: DateTime
    $note: String
    $isSppDaXo: Boolean
    $isAps: Boolean
    $isDependantsPension: Boolean
    $isPensionSharing: Boolean
    $parentGuardianId: UUID
  ) {
    upsertOvrecommend(
      ovrecommendId: $ovrecommendId
      reviewId: $reviewId
      contactId: $contactId
      accountId: $accountId
      goalId: $goalId
      productProviderId: $productProviderId
      productNameId: $productNameId
      name: $name
      action: $action
      isNewPlanRequired: $isNewPlanRequired
      # ownership: $ownership
      planType: $planType
      solutionType: $solutionType
      isXo: $isXo
      withdrawalReason: $withdrawalReason
      # withdrawalAmount: $withdrawalAmount # not used, instead calculated
      urgency: $urgency
      urgencyReason: $urgencyReason
      startDate: $startDate
      endDate: $endDate
      note: $note
      isSppDaXo: $isSppDaXo
      isAps: $isAps
      isDependantsPension: $isDependantsPension
      isPensionSharing: $isPensionSharing
      parentGuardianId: $parentGuardianId
      isDentist: false
    ) {
      ok
      errors
      ovrecommend {
        id
        recommends {
          ...RecommendsFragment
        }
      }
    }
  }
`;

export const GENERATE_RECOMMENDATION_POT = gql`
  mutation GenerateOvrecommendPots(
    $ovrecommendId: UUID!
    $accountId: UUID!
    $args: [GenerateOVRPotBatchArguments!]!
  ) {
    generateOvrpotBatch(
      args: $args
      ovrecommendId: $ovrecommendId
      accountId: $accountId
    ) {
      ovrecommendpots {
        ...OVPot
      }
      errors
    }
  }
  ${OV_POT_FRAGMENT}
`;
